export default {
    scrollTo(itemId) {
        let element = document.getElementById(itemId);
        window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth',
        });
    }
}